module.exports = __webpack_public_path__ + "img/mood3.b4a2510d.png";